<template>
  <div class="row">
    <v-col
      :cols="9"
    >
      <div class="text-center">
        <v-btn
          class="ma-2"
          tile
          outlined
          @click="addWindow2Method()"
          :disabled="!this.$store.state.Window1.windowTypeSelected1 || !this.$store.state.Window1.widthWindow1 || !this.$store.state.Window1.heightWindow1 || !this.$store.state.Window1.nameWindow1"
          color="success"
          >
          <v-icon left>mdi-plus</v-icon> Добавить окно
        </v-btn>
        <v-btn
          class="ma-2"
          tile
          dark
          @click="removeWindow2Method() || clearWindow2params()"
          v-if="this.$store.state.Window1.addWindow2"
          color="primary"
          >
          <v-icon left>mdi-minus</v-icon> Удалить окно
        </v-btn>
      </div>
    </v-col>
    <v-col
      :cols="3"
    >
    </v-col>
  </div>
</template>

<script>
export default {
  name: 'Btn1',
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    addWindow2Method (value) {
      this.$store.commit('addWindow2Computed', value)
    },
    removeWindow2Method (value) {
      this.$store.commit('removeWindow2Computed', value)
    },
    clearWindow2params (value) {
      this.$store.commit('clearWindow2Params', value)
    }
  }
}
</script>

<style>

</style>
